import { Directive } from '@angular/core';

@Directive({
    selector: '[zappPermissionsExcept]',
    standalone: false
})
export class PermissionsExceptDirective {

  constructor() { }

}
